// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"ac3cf209","453":"b7af7c36"}[chunkId] + ".chunk.js";
};